export const actionType = {
  SET_USER: "SET_USER",
  SET_CONCEPTS: "SET_CONCEPTS",
  SET_USERS: "SET_USERS",
  SET_TRAINERS: "SET_TRAINERS",

  // favourites
  SET_FAVOURITES: "SET_FAVOURITES",

  // Video Detail By Id
  SET_CONCEPT_BY_ID: "SET_CONCEPT_BY_ID",

  // alert
  SET_ALERT_STATE: "SET_ALERT_STATE",
  SET_ALERT_TYPE: "SET_ALERT_TYPE",
  // Loader
  SET_MAIN_LOADER: "SET_MAIN_LOADER",
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionType.SET_USER:
      return {
        ...state,
        user: action.user,
      };

    case actionType.SET_USERS:
      return {
        ...state,
        allUsers: action.allUsers,
      };

    // Concepts actions
    case actionType.SET_CONCEPTS:
      return {
        ...state,
        allConcepts: action.allConcepts,
      };

    case actionType.SET_CONCEPT_BY_ID:
      return {
        ...state,
        conceptDetailById: action.conceptDetailById,
      };

    case actionType.SET_FAVOURITES:
      return {
        ...state,
        favourites: action.favourites,
      };

    // trainers actions
    case actionType.SET_TRAINERS:
      return {
        ...state,
        allTrainers: action.allTrainers,
      };

    // alert
    case actionType.SET_ALERT_STATE:
      return {
        ...state,
        alertState: action.alertState,
      };

    case actionType.SET_ALERT_TYPE:
      return {
        ...state,
        alertType: action.alertType,
      };

    // Main Loader state
    case actionType.SET_MAIN_LOADER:
      return {
        ...state,
        mainLoader: action.mainLoader,
      };

    default:
      return state;
  }
};

export default reducer;
